{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-300200x",
  "sheetId": "AnalysisOfProfitOrLossByFunction",
  "label": "[310100] Detailed analysis and breakdown of expenses by function of expense method (MPERS)",
  "description": "Detailed analysis and breakdown of expenses by function of expense method",
  "controls": [
    {
      "qname": "ssmt-mpers:AnalysisOfProfitOrLossByFunctionHeader",
      "label": "Analysis of profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 1
      }
    },
    {
      "qname": "ssmt-mpers:StatementOfProfitOrLossHeader",
      "label": "Statement of profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:RevenueHeader",
      "label": "Revenue",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfGoodsHeader",
      "label": "Revenue from sale of goods",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfTelecommunicationEquipment",
      "label": "Revenue from sale of broadband and telecommunication",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfProperty",
      "label": "Revenue from property development",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfConstructionContracts",
      "label": "Revenue from construction contracts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfCleanWaterTreatmentAndDisposalOfWasteWater",
      "label": "Revenue from sale of clean water, treatment and disposal of waste water",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfFoodAndBeverage",
      "label": "Revenue from sale of food and beverage",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfAgriculturalProduce",
      "label": "Revenue from sale of agricultural produce",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfOilAndGasProducts",
      "label": "Revenue from sale of oil and gas products",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromSaleOfOtherGoods",
      "label": "Revenue from sale of other goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromSaleOfGoods",
      "label": "Total revenue from sale of goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfServicesHeader",
      "label": "Revenue from rendering of services",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromEntertainmentOperations",
      "label": "Revenue from rendering of entertainment services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfTelecommunicationServices",
      "label": "Revenue from rendering of telecommunication services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfTransportServices",
      "label": "Revenue from rendering of transportation services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfInformationTechnologyServices",
      "label": "Revenue from rendering of information technology services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromEducationalServices",
      "label": "Revenue from rendering of educational services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromHealthcareServices",
      "label": "Revenue from rendering of healthcare services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfCargoAndMailTransportServices",
      "label": "Revenue from rendering of shipping and shipping related services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RevenueFromRenderingOfOtherServices",
      "label": "Revenue from rendering of other services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromRenderingOfServices",
      "label": "Total revenue from rendering of services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:InterestIncomeHeader",
      "label": "Interest income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:InterestIncomeOnLoansAndReceivables",
      "label": "Interest income on loans, advances and financing",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InterestIncomeOnOtherFinancialAssets",
      "label": "Interest income on other financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromInterest",
      "label": "Total interest income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherFeeAndCommissionIncomeHeader",
      "label": "Other fee and commission income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:BrokerageFeeIncome",
      "label": "Gross brokerage and other charges",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:PortfolioAndOtherManagementFeeIncome",
      "label": "Underwriting commissions and fund management income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherFeesAndCommissionIncome",
      "label": "Other fee and commission income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:FeeAndCommissionIncome",
      "label": "Total other fee and commission income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromDividends",
      "label": "Dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RentalIncome",
      "label": "Rental income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevenueFromRoyalties",
      "label": "Royalty income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherRevenue",
      "label": "Other revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Revenue",
      "required": true,
      "label": "Total revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:CostOfSalesHeader",
      "label": "Cost of sales",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:CostOfInventories",
      "label": "Cost of inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ConstructionContractCost",
      "label": "Construction contract costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EnergyExpense",
      "label": "Energy costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:PropertyDevelopmentAndProjectManagementExpense",
      "label": "Property development costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCostOfSales",
      "label": "Other cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CostOfSales",
      "required": true,
      "label": "Total cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherIncomesHeader",
      "label": "Other incomes",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:AmortisationOfDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BadDebtsRecovered",
      "label": "Bad debts recovered",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherIncomeDividend",
      "label": "Dividend, other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ForeignExchangeGainHeader",
      "label": "Foreign exchange gain",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:RealisedGainOnForeignExchange",
      "label": "Realised gain on foreign exchange",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:UnrealisedGainOnForeignExchange",
      "label": "Unrealised gain on foreign exchange",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsOnForeignExchange",
      "label": "Total foreign exchange gain",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:GainOnDisposalOfSubsidiariesAssociatesAndJointVenturesHeader",
      "label": "Gain on disposal of subsidiaries, associates and joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:GainsFromDisposalOfSubsidiaries",
      "label": "Gain on disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsFromDisposalOfAssociates",
      "label": "Gain on disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsFromDisposalOfJointVentures",
      "label": "Gain on disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsOnDisposalOfSubsidiaryJointVenturesAndAssociates",
      "label": "Total gain on disposal of subsidiaries, associates and joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsOnDisposalOfOtherInvestments",
      "label": "Gain on disposal from other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsOnDisposalsOfPropertyPlantAndEquipment",
      "label": "Gain on disposals of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GainsOnDisposalsOfNoncurrentAssets",
      "label": "Gains on disposal of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherGainsRecognisedInProfitOrLossFairValueMeasurementAssets",
      "label": "Gain on revaluation",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherInterestIncome",
      "label": "Interest income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:IncomeFromManagementFees",
      "label": "Management fees, other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:GainsLossesOnFinancialAssetsAtFairValueThroughProfitOrLoss",
      "label": "Net fair value gain on derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:FairValueGainOnRecycleOfForexReserveUponDisposalOfSubsdiaries",
      "label": "Net fair value gain on recycle of forex reserve upon disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:MiscellaneousOtherFeesAndCommissionIncome",
      "label": "Other fee and commission, other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherRentalIncome",
      "label": "Other rental income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherRentalIncomeOnLandAndBuildings",
      "label": "Rental income on land and buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossRecognisedInProfitOrLossHeader",
      "label": "Reversal of impairment loss recognised in profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossRecognisedInProfitOrLossLoansAndAdvances",
      "label": "Reversal of impairment loss on receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ReversalOfInventoryWritedown",
      "label": "(Reversal of)/Impairment loss on inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-smes:ReversalOfInventoryWritedown"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ReversalOfImpairmentLossRecognisedInProfitOrLossIntangibleAssetsOtherThanGoodwill",
      "label": "Reversal of impairment loss on intangible assets other than goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossRecognisedInProfitOrLossGoodwill",
      "label": "Reversal of impairment loss on goodwilll",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ReversalOfImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
      "label": "Reversal of impairment loss on property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossRecognisedInProfitOrLossAssociates",
      "label": "Reversal of impairment loss on investment in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossRecognisedInProfitOrLossJointVentures",
      "label": "Reversal of impairment loss on investment in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ReversalOfImpairmentLossForOtherAssets",
      "label": "Reversal of impairment loss on other assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ReversalOfImpairmentLossRecognisedInProfitOrLoss",
      "label": "Total reversal of impairment loss recognised in profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherRoyaltyIncome",
      "label": "Royalty/franchise income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GrantsOrIncentivesReceivedByMalaysianGovernmentOrAgencies",
      "label": "Grant or incentives by Malaysian government or it's agencies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:GrantsOrIncentivesReceivedByForeignGovernmentOrAgencies",
      "label": "Grant or incentives by foreign government or its agencies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ContributionsReceivedByLocalContributor",
      "label": "Contributions or donations by local contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ContributionsReceivedByForeignContributor",
      "label": "Contributions or donations by foreign contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ContributionsReceivedByUnknownContributor",
      "label": "Contributions or donations by unknown contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherMiscellaneousIncome",
      "label": "Miscellaneous other operating income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherIncome",
      "required": true,
      "label": "Total other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherExpensesHeader",
      "label": "Other expenses",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:AuditorsRemunerationHeader",
      "label": "Auditor's remuneration",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mpers:AuditorsRemunerationForAuditServices",
      "label": "Auditor's remuneration for audit services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AuditorsRemunerationForOtherServices",
      "label": "Auditor's remuneration for other services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:AuditorsRemuneration",
      "label": "Total auditor's remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:AmortisationExpense",
      "label": "Amortisation expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:DepreciationPropertyPlantAndEquipment",
      "label": "Depreciation of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NaturalDisasterRelatedExpenses",
      "label": "Natural disaster related expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossOnDisposalOfSubsidiariesAssociatesAndJointVenturesHeader",
      "label": "Loss on disposal of subsidiaries, associates and joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:LossOnDisposalOfSubsidiaries",
      "label": "Loss on disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossOnDisposalOfAssociates",
      "label": "Loss on disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossOnDisposalOfJointVentures",
      "label": "Loss on disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossOnDisposalOfSubsidiariesAssociatesAndJointVentures",
      "label": "Total loss on disposal of subsidiaries, associates and joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:LossesOnDisposalsOfInvestments",
      "label": "Loss on disposal from other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossesOnDisposalsOfPropertyPlantAndEquipment",
      "label": "Loss on disposal of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossesOnDisposalsOfNoncurrentAssets",
      "label": "Loss on disposal of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LossOnRevaluationOfFinancialInstruments",
      "label": "Loss on revaluation",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ProvisionForLiabilitiesAndCharges",
      "label": "Provision for liabilities and charges",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ProvisionForGuaranteeAndWarranties",
      "label": "Provision of warranties and guarantees",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RentalExpense",
      "label": "Rental expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RoyaltyExpense",
      "label": "Royalty expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EmployeeBenefitsExpenseHeader",
      "label": "Employee benefits expense",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:WagesAndSalaries",
      "label": "Wages, salaries and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BonusExpenses",
      "label": "Bonus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ExpenseFromSharebasedPaymentTransactionsWithEmployees",
      "label": "Share-based compensation expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EmployeeShareBasedPayment",
      "label": "Share option expensese",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:SocialSecurityContributions",
      "label": "Social security contributions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TerminationBenefitsExpense",
      "label": "Termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PostemploymentBenefitExpenseDefinedContributionPlans",
      "label": "Defined contribution plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PostemploymentBenefitExpenseDefinedBenefitPlans",
      "label": "Defined benefit plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherLongtermBenefits",
      "label": "Other long-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherShorttermEmployeeBenefits",
      "label": "Other short-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherEmployeeExpense",
      "label": "Other employee expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:EmployeeBenefitsExpense",
      "label": "Total employee benefits expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsRemunerationHeader",
      "label": "Director's remuneration",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mpers:WagesAndSalariesToDirectors",
      "label": "Salaries and other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BonusToDirectors",
      "label": "Bonus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:KeyManagementPersonnelCompensationSharebasedPayment",
      "label": "Share option expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BenefitsInKindExpenses",
      "label": "Benefits-in-kind",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsFees",
      "label": "Fees",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:PerformanceIncentives",
      "label": "Performance incentives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RetirementBenefitsDefinedContributionPlans",
      "label": "Defined contribution plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RetirementBenefitsDefinedBenefitPlans",
      "label": "Defined benefit plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherDirectorsRemuneration",
      "label": "Other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DirectorsRemuneration",
      "label": "Total Director's remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherMiscellaneousExpenses",
      "label": "Other miscellaneous expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherExpenseByFunction",
      "required": true,
      "label": "Total other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mpers:FinanceIncomeHeader",
      "label": "Finance income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt-mpers:InterestIncomeDueFromRelatedParties",
      "label": "Finance income due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherFinanceIncome",
      "label": "Other finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:FinanceIncome",
      "required": true,
      "label": "Total finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    }
  ],
  "roleId": "role-310100-mpers",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-300200x",
  "taxonomy": "FS-MPERS"
}